import { render } from "./StationParent.vue?vue&type=template&id=3b2e8f1d&scoped=true"
import script from "./StationParent.vue?vue&type=script&lang=js"
export * from "./StationParent.vue?vue&type=script&lang=js"

import "./StationParent.vue?vue&type=style&index=0&id=3b2e8f1d&scoped=true&lang=css"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2e8f1d"]])

export default __exports__